import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
    API 
} from 'aws-amplify'

import { 
    ErrorText,
    BlueTint 
} from '../../Styles/BaseStyles'

import { 
    LogInDiv, 
    LogInComponentsDiv, 
    LogInFieldsDiv,
    TitleIconButton,
    QuickFillerButtonDiv,
    QuickFillerButton,
    LogInTitle, 
    LogInFormDiv, 
    RememberMeLabel, 
    RememberMeBox, 
    RememberMeSpan, 
    LogInRowDiv,
    FullLogInDiv,
    LogInHeader,
    EmailInputField, 
    PasswordInputField, 
    SignUpButtonDiv, 
    SignInButtonDiv, 
    QuestionDiv, 
    ForgotPasswordDiv, 
    SignUpButton, 
    SignInButton, 
    QuestionPhrase, 
    ForgotPasswordButton 
} from '../../Styles/Components/LogInFieldsStyles'

import { 
    useForm 
} from 'react-hook-form'

import { useDispatch } from "react-redux"

import { setUser, setApplicationID } from '../../Redux/Slices/UserSlice'
import { signInError } from '../../Redux/Slices/LogInSlice'
import { setStorage } from '../../Redux/Slices/UserSlice'

import * as queries from '../../graphql/queries'

function LogInFields(props){
    const { register, errors, handleSubmit } = useForm()
    let history = useHistory()

    const dispatch = useDispatch()

    var authErrorMessage = ''

    function mainPage(e){
        history.push('/')
    }

    function signupTransition(){
        history.push('/signup')
    }

    function formActions(data){
        signin(data)
    }

    function forgotPassword() {
        history.push('/forgotpassword')
    }

    async function signin(data) {
        var email = data.email
        var password = data.password
        var remembercreds = data.remembercreds
        var storage = remembercreds ? 'localstorage' : 'sessionstorage' 
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        dispatch(setStorage({storage: storage}))
        try {
            const user = await Auth.signIn(email, password)
            const userID = user.attributes.sub
            const userData = await API.graphql({ query: queries.getUser, variables: { id: userID}})
            const stripeData = {
                stripe_id: userData.data.getUser.stripe_id,
                subscription_id: userData.data.getUser.subscription_id,
                subscription_status: userData.data.getUser.subscription_status
            }
            dispatch(setUser({user: {...user, ...stripeData}}))
            dispatch(setApplicationID({applicationID: user.attributes.sub}))
            history.push('/hub')
        } catch (error) {
            switch(error.code){
                case 'NotAuthorizedException':
                    authErrorMessage = 'Invalid email or password'
                    break
                case 'UserNotFoundException':
                    authErrorMessage = 'Invalid email'
                    break
                default:
                    authErrorMessage = 'Unknown error during log in'
                    break
            }
            console.log(error)
            dispatch(signInError({errorPhrase: authErrorMessage}))
        }
    }

    return(
        <>
            <LogInDiv id="login-section">
                <LogInComponentsDiv>
                    <LogInFieldsDiv>
                        <QuickFillerButtonDiv>
                            <TitleIconButton />
                            <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                        </QuickFillerButtonDiv>
                        <LogInTitle>Log in</LogInTitle>
                        <LogInFormDiv>
                            <form>
                                <LogInRowDiv>
                                    <FullLogInDiv>
                                        <LogInHeader>Email</LogInHeader>
                                        <EmailInputField 
                                            type="text" name="email" placeholder="" 
                                            ref={
                                                register({ 
                                                    required: true,
                                                    maxLength: 320, 
                                                    pattern: /^(?=[a-zA-Z0-9._]{5,20}$)(?!.*[_.]{2})[^_.].*[^_.]$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                })
                                            }
                                        />
                                    </FullLogInDiv>
                                </LogInRowDiv>
                                <LogInRowDiv>
                                    <FullLogInDiv>
                                        <LogInHeader>Password</LogInHeader>
                                        <PasswordInputField 
                                            type="password" name="password" placeholder=""
                                            ref={
                                                register({ 
                                                    required: true,
                                                    minLength: 8,
                                                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
                                                })
                                            }
                                        />
                                    </FullLogInDiv>
                                </LogInRowDiv>
                                {(errors.emailuser?.type === "required" || errors.password?.type === "required") && <ErrorText p={0} ml={0} mr={0} mt="0.2rem" mb="0.8rem">*please enter your credentials</ErrorText>}
                                {(!(errors.emailuser?.type === "required" || errors.password?.type === "required") && (errors.emailuser?.type === "maxLength" || errors.emailuser?.type === "pattern" || errors.password?.type === "minLength" || errors.password?.type === "pattern")) && <ErrorText p={0} ml={0} mr={0} mt="0.2rem" mb="0.8rem">*invalid email or password</ErrorText>}
                                <RememberMeLabel>
                                    <RememberMeBox 
                                        type="checkbox" name="remembercreds" 
                                        ref={
                                            register({ 
                                                required: false,
                                            })
                                        }
                                    />
                                    <RememberMeSpan>Remember Me</RememberMeSpan>
                                </RememberMeLabel><br/>
                                <SignInButtonDiv>
                                    <SignInButton onClick={handleSubmit(formActions)}>Sign in</SignInButton>
                                </SignInButtonDiv>
                            </form>
                            <ForgotPasswordDiv>
                                <ForgotPasswordButton onClick={forgotPassword}>Forgot password?</ForgotPasswordButton>
                            </ForgotPasswordDiv>
                            <QuestionDiv>
                                <QuestionPhrase>Not registered?</QuestionPhrase>
                            </QuestionDiv>
                            <SignUpButtonDiv>
                                <SignUpButton onClick={signupTransition}>Create account</SignUpButton>
                            </SignUpButtonDiv>
                        </LogInFormDiv>
                    </LogInFieldsDiv>
                </LogInComponentsDiv>
            </LogInDiv>
        </>
    )
}

export default LogInFields